import { create } from 'zustand'

interface FacesheetCardCollapseState {
  // Bumps on every collapse-all or expand-all so a card that already matches
  // the target still learns a new command arrived.
  revision: number
  open: boolean
  actions: {
    collapseAll: () => void
    expandAll: () => void
  }
}

export const useFacesheetCardCollapseStore =
  create<FacesheetCardCollapseState>()((set) => ({
    revision: 0,
    open: true,
    actions: {
      collapseAll: () =>
        set((state) => ({ revision: state.revision + 1, open: false })),
      expandAll: () =>
        set((state) => ({ revision: state.revision + 1, open: true })),
    },
  }))
